/* eslint-disable no-console */
import * as REST from 'api/rest';

import Notification from 'components/Notification';
import * as OBJ_ACTION_TYPES from 'store/objects/action-types';
import { OBJECT_TYPES } from 'enum/object';
import {
  generateTokenStarted,
  generateTokenSuccess,
  generateTokenFailed,
  regenPSKFailed,
  regenPSKStarted,
  regenPSKSuccess,
  generateImageStarted,
  generateImageSuccess,
  generateImageFailed,
} from 'store/objects/actions';

export function getThings({ ecosystemUUID }) {
  return async (dispatch, getState) => {
    try {
      const { currentCustomer } = getState().customers;
      const things = await REST.fetchObjects({
        customer: currentCustomer,
        ecosystem: ecosystemUUID,
        type: OBJECT_TYPES.THING,
      });
      dispatch({ type: OBJ_ACTION_TYPES.GET_THINGS_SUCCESS, payload: things });
    } catch (err) {
      console.log(err);
    }
  };
}

export function generateToken(gateway, option) {
  return async (dispatch, getState) => {
    try {
      const ecosystem = getState().ecosystems.currentEcosystem;
      const customer = getState().customers.currentCustomer;
      const platform = option.value;
      dispatch(generateTokenStarted());
      const { token } = await REST.getGatewayToken({
        customer: customer.uuid,
        ecosystem: ecosystem.uuid,
        gateway: gateway.uuid,
        platform,
      });
      const url = platform === 'strongswan' ? REST.getConfigLink(token, platform) : '';
      const storeGateway = localStorage.getItem(gateway.uuid)
        ? JSON.parse(localStorage.getItem(gateway.uuid))
        : { name: gateway.name };
      storeGateway[platform] = {
        token,
        url,
        createdAt: new Date(),
        updatedAt: new Date(),
        label: option.label,
      };
      localStorage.setItem(gateway.uuid, JSON.stringify(storeGateway));
      dispatch(generateImageStarted({ uuid: gateway.uuid, platform }));
      if (platform === 'strongswan') {
        dispatch(generateImageSuccess({ uuid: gateway.uuid, platform }));
        Notification({
          message: `${option.label} is ready to download from ${gateway.name}`,
        });
      }
      dispatch(generateTokenSuccess());
    } catch (err) {
      dispatch(generateTokenFailed(err));
    }
  };
}

export function generateImgTimeout(gateway, option) {
  return async (dispatch) => {
    const storeGateway = localStorage.getItem(gateway.uuid) ? JSON.parse(localStorage.getItem(gateway.uuid)) : {};
    if (storeGateway) {
      storeGateway[option.value] = {
        ...storeGateway[option.value],
        error: 'Time out. Please try again.',
      };
    }
    localStorage.setItem(gateway.uuid, JSON.stringify(storeGateway));
    dispatch(
      generateImageFailed({
        uuid: gateway.uuid,
        platform: option.value,
        message: '',
      }),
    );
  };
}

export function regeneratePSK(gatewayUUID) {
  return async (dispatch, getState) => {
    try {
      const ecosystem = getState().ecosystems.currentEcosystem;
      const customer = getState().customers.currentCustomer;
      dispatch(regenPSKStarted());
      const result = await REST.regeneratePSK({
        customer: customer.uuid,
        ecosystem: ecosystem.uuid,
        gateway: gatewayUUID,
      });
      dispatch(
        regenPSKSuccess({
          psk: result.psk,
          ecoUUID: ecosystem.uuid,
          gatewayUUID,
        }),
      );
    } catch (error) {
      dispatch(regenPSKFailed(error));
    }
  };
}
